var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudyLm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5431 34.2134C7.79394 34.2134 3.94397 30.3634 3.94397 25.6142C3.94397 20.8651 7.79394 17.0151 12.5431 17.0151C13.5729 17.0151 14.5604 17.1961 15.4755 17.528C17.2811 13.1117 21.6204 10 26.6864 10C33.3728 10 38.7931 15.4203 38.7931 22.1067C38.7931 22.4012 38.7826 22.6933 38.7619 22.9826C40.7839 23.9136 42.1875 25.9578 42.1875 28.3297C42.1875 31.5792 39.5533 34.2134 36.3039 34.2134H12.5431Z",
    fill: "#A3B6C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudyLm);
export default __webpack_public_path__ + "static/media/cloudy-lm.b5e8281746c7eb69755c9ade1222378e.svg";
export { ForwardRef as ReactComponent };